import "./ProgressSteps.scss";
import React from "react";

const ProgressBar = ({ value }) => {
  return (
    <div className="progress">
      <div
        className="progress-done"
        style={{ opacity: 1, width: `${value}%` }}
      ></div>
    </div>
  );
};

const ProgressSteps = ({ title, value }) => {
  return (
    <div className="progress-steps">
      <ProgressBar value={value} />
      <div className={`step-title ${value == 100 ? 'success-step-color' : ''}`}>{title}</div>
    </div>
  );
};

export default ProgressSteps;
